import type { GenerationTier } from '../types';

const TIER_LABELS: Record<GenerationTier, string> = {
  tier1: 'Tier 1',
  tier2: 'Tier 2',
  tier3: 'Tier 3',
  tier4: 'Tier 4',
};

export function GenerationTierBadge({ tier }: { tier: GenerationTier }) {
  return (
    <span className="inline-flex whitespace-nowrap rounded-md bg-violet-50 px-2 py-1 text-xs font-medium text-violet-700">
      {TIER_LABELS[tier]}
    </span>
  );
}
